"use strict"
exports.__esModule = true;
exports.ParachuteBoxIconConfig = {
  name: 'ParachuteBoxIcon',
  height: 512,
  width: 512,
  svgPath: 'M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z',
  yOffset: 0,
  xOffset: 0,
};
exports.ParachuteBoxIcon = require('../createIcon').createIcon(exports.ParachuteBoxIconConfig);
exports["default"] = exports.ParachuteBoxIcon;